// CSS class names with special meaning to the Meticulous recorder. Apply them
// via `className` on the narrowest element that needs the behavior.

// Ignore the element's subtree when comparing screenshots, so non-deterministic
// content (timestamps, autosave status, live data) doesn't produce false
// positive diffs in Meticulous test runs. The element is still recorded.
// https://app.meticulous.ai/docs/how-to/fix-false-positive-diffs
export const METICULOUS_IGNORE = 'meticulous-ignore';

// Redact the element's contents at recording time so sensitive data never
// leaves the user's browser: it's excluded from DOM snapshots, click-target
// text, and keyboard events. Prefer wrapping with `<SensitiveInfoWrapper>`
// (src/util/SensitiveInfoWrapper.tsx), which applies this class alongside the
// equivalent Datadog masking.
// https://app.meticulous.ai/docs/session-recording/redaction
export const METICULOUS_REDACT_RECORDING = 'meticulous-redact-recording';
